// extracted by mini-css-extract-plugin
export default {"header":"DepartmentList_header__fkE+j","filters":"DepartmentList_filters__32FAt"};